import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { usePermissions } from '../../hooks/usePermissions'
import LoadingSpinner from './LoadingSpinner'
import { useEffect } from 'react'
import { toast } from 'react-hot-toast'
import { useLanguageStore } from '../../store/languageStore'
import { useModuleStore } from '../../store/moduleStore'
import { isModuleAllowed } from '../../utils/moduleHelpers'

interface ProtectedRouteProps {
  children: React.ReactNode
  path?: string
  requiredPermission?: string
}

export default function ProtectedRoute({ children, path, requiredPermission }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuthStore()
  const { hasPermission, isPermissionsLoading, isAdmin } = usePermissions()
  const location = useLocation()
  const { language } = useLanguageStore()
  const modules = useModuleStore()

  const currentPath = path || location.pathname

  useEffect(() => {
    if (!isAuthenticated || isPermissionsLoading) return
    if (requiredPermission === 'admin') {
      if (!isAdmin) {
        toast.error(language === 'ar' ? 'هذه الصفحة للمسؤولين فقط' : 'This page is for admins only')
      }
      return
    }
    if (!hasPermission(currentPath)) {
      toast.error(language === 'ar' ? 'ليس لديك صلاحيات للدخول لهذه الصفحة' : 'You do not have permission to access this page')
    }
  }, [isAuthenticated, isPermissionsLoading, hasPermission, currentPath, language, requiredPermission, isAdmin])

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Admin-only routes: Admin is enough (do not also require menu ACL / MenuVisibility).
  if (requiredPermission === 'admin') {
    if (isPermissionsLoading && !isAdmin) {
      return <LoadingSpinner />
    }
    if (!isAdmin) {
      return <Navigate to="/" replace />
    }
    return <>{children}</>
  }

  if (isPermissionsLoading) {
    return <LoadingSpinner />
  }

  if (!hasPermission(currentPath)) {
    return <Navigate to="/" replace />
  }

  if (modules.modulesLoaded && !isModuleAllowed(currentPath, modules)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}



